import { Grid, useMediaQuery } from "@mui/material";
import { apiClient } from "api/apiClient";
import { useLanguage } from "LanguageContext";
import _ from "lodash";
import Markdown from "markdown-to-jsx";
import Share from "Pages/components/Share";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import Box from "ReusableComponents/Box";
import Text from "ReusableComponents/Text";
import { COLORS, SIZES } from "theme";
import RecentPost from "../RecentPost/RecentPost";
import BlogChips from "./BlogChips";

const BlogPage = () => {
  const small = useMediaQuery("(max-width: 600px)");
  const location = useLocation();
  const [blogData, setBlogData] = useState({});
  const [metaObj, setMetObj] = useState({});
  const [blogs, setBlogs] = useState([]);
  const { selectedLanguage } = useLanguage();

  useEffect(() => {
    if (location) {
      const slug = location.pathname.split("/")[3];
      apiClient.getBlogBySlug(slug, selectedLanguage).then((res) => {
        setBlogData(res?.data[0]?.attributes);
        setMetObj(res?.data[0].attributes);
      });
    }
  }, [location]);

  useEffect(() => {
    apiClient.getBlogs(1, 3, selectedLanguage).then((res) => {
      setBlogs(res?.data);
    });
  }, []);

  return (
    <>
      <Grid item xs={12} style={{ padding: 0 }}>
        <img
          src={blogData?.featured_media?.data?.attributes?.url}
          alt={blogData?.featured_media?.data?.attributes?.alternativeText}
          style={{
            width: "100%",
            height: "100%",
            paddingTop: small ? "50px" : 0,
          }}
        />
      </Grid>

      <Grid
        item
        xs={12}
        lg={9}
        style={{
          background: COLORS.lightBlack,
          padding: small && "0 40px",
        }}
      >
        <Box
          display="flex"
          w={small ? "100%" : "85%"}
          className={"blog_content"}
          margin="40px auto"
          flexDirection="column"
        >
          <Box textAlign="left">
            <Text
              textColor="white"
              fontWeight="archiabold"
              fontSize={small ? SIZES.fourteen : SIZES.forty}
              margin="0"
            >
              <h4 class="h4-custom">{blogData?.blog_title}</h4>
            </Text>
          </Box>

          <BlogChips
            chips={blogData?.blog_categories?.data}
            small={small}
            author={blogData?.blog_author?.data?.attributes?.author_name}
            publishedAt={blogData?.published_date}
          />
          {small && (
            <Grid item xs={12} style={{ background: COLORS.lightBlack }}>
              <Share small={small} />
            </Grid>
          )}
          <Box>
            <Text
              fontSize={small ? "12px" : "20px"}
              textColor="white"
              lineHeight="2"

              // style={{FontFace}}
            >
              <Markdown children={blogData?.blog_content} />
            </Text>
          </Box>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        lg={3}
        style={{
          background: COLORS.lightBlack,
          padding: small ? "0 40px" : "120px 15px",
        }}
      >
        <RecentPost blogData={blogs} small={small} />
      </Grid>
      {/* <Grid
        item
        xs={12}
        style={{
          background: COLORS.lightBlack,
        }}
      >
        <FaqComponent small={small} />
      </Grid> */}

      {!_.isEmpty(metaObj) && (
        <Helmet>
          <title>{metaObj?.blog_title}</title>

          <link
            rel="publisher"
            href={`https://www.eulermotors.com/${metaObj?.blog_slug}`}
          />
          <link rel="icon" href="/fav.ico" />

          <meta name="title" content={metaObj?.blog_title} />
          <meta name="description" content={metaObj?.blog_description} />
        </Helmet>
      )}
    </>
  );
};

export default BlogPage;
